import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import Util from 'service/util';
import Protected from 'component/Protected';

class UnitServiceRow extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { selected: false };
  }

  render()
  {
    let s = this.props.service;
    return (
      <label className="table-row">
        <div className="col-unit-srv-sel">
          <input type="checkbox" checked={this.state.selected}
                onChange={ e=>this.setState({selected: e.target.checked}) } />
        </div>
        <div className="col-unit-srv-id">{ s.id }</div>
        <div className="col-unit-srv-grp" title={s.srv_grp}>{ s.grp_name }</div>
        <div className="col-unit-srv-name">{ s.srv_name }</div>
        <div className="col-unit-srv-price">${ Util.nf2(s.price) }</div>
        <div className="col-unit-srv-desc">{ s.srv_desc }</div>
        {/*<div className="col-unit-srv-mod-by" title={'更改日期: ' + Util.ShortDate(s.mod_dtm)}>{ s.mod_by }</div>*/}
        <div className="col-unit-srv-create-date" title={Util.FullDate(s.create_dtm)}>{ Util.ShortDate(s.create_dtm) }</div>
        <div className="col-unit-srv-mod-date" title={Util.FullDate(s.mod_dtm)}>{ Util.ShortDate(s.mod_dtm) }</div>
        <div className="col-unit-srv-mod-by">{ s.mod_by }</div>
        <div className="col-unit-srv-btn-grp">
          <Protected allow={['ADMIN']}>
            <button className="btn-edit" title="編輯" onClick={e=>this.props.showEditModal(s)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Protected>
        </div>
      </label>
    );
  }
}

export default UnitServiceRow;
